export default __webpack_public_path__ + "static/media/online.a7b9bd16.png";